"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var employee_service_1 = require("./employee.service");
var employeeService;
exports.employeeService = employeeService;
var init = function (accessToken, baseUrl) {
    exports.employeeService = employeeService = new employee_service_1.EmployeeService();
    employeeService.setAccessToken(accessToken);
    employeeService.setBaseUrl(baseUrl);
};
exports.init = init;
